import { Button, Checkbox, Dialog, Divider, FormControl, Grid, MenuItem, Radio, RadioGroup, Select, Switch, TextField, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useState, useEffect } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import { FormProvider, useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { useStyles } from '../../styles';
import { Box } from '@mui/material';
import { EventFormValues } from '../../utils/interfaces';
import { getSessionDetails, postEventQuestionnaire } from '../../../../Utils/apiService';
import CloseIcon from '@mui/icons-material/Close';
import { AppButton } from '../../globalComponent/AppButton';
import KenColors from '../../utils/kenColors';

const alphabet = 'abcdefghijklmnopqrstuvwxyz';

interface Question {
  scaleLabels: { [key: number]: string }; // always an object
  minGrade: number | any;
  maxGrade: number | any;
  shortAnswer: string;
  id: number;
  type: string;
  required: boolean;
  options: string[];
  questionLabel: string;
}

const FeedBackForm = () => {
  const classes = useStyles();
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const eventId: any = searchParams.get('eventId');
  const [triggerFeedbackForm, setTriggerFeedbackForm] = useState<boolean>(false);
  const [sessions, setSessions] = useState<any[]>([]);
  const defaultOptions = ['Multiple Choice', 'Yes/No', 'Short Answer', 'Linear Scale'];
  const [questions, setQuestions] = useState<Question[]>([
    {
      id: 1,
      type: '',
      required: false,
      options: [],
      maxGrade: 0,
      shortAnswer: '',
      minGrade: null,
      questionLabel: '',
      scaleLabels: {} // Ensure it's always an object
    },
  ]);

  const [selectedSession, setSelectedSession] = useState<any>(null);
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).replace(/ /g, '-'); // eg: "29-Apr-2025"
  };
  useEffect(() => {
    const fetchSessionDetails = async () => {
      if (!eventId) {
        console.error('eventId is null');
        return;
      }
      try {
        const sessionRes: any = await getSessionDetails(eventId); // Await the async call
        if (sessionRes && sessionRes.result) {
          const parsedData = typeof sessionRes.result === 'string'
            ? JSON.parse(sessionRes.result)
            : sessionRes.result;
          const session = parsedData?.sessions;
          setSessions(session);
          console.log('sessionRes123121212', session);
        } else {
          console.error('sessionRes.data is undefined or null');
        }
      } catch (error) {
        console.error('Error while fetching session details:', error);
      }
    };
    fetchSessionDetails();
  }, []);

  const handleTriggerFeedbackForm = (session: any) => {
    setSelectedSession(session);
    setTriggerFeedbackForm(true);

  }
  const handleCloseDialog = () => {
    setTriggerFeedbackForm(false);
    setQuestions([{
      id: 1,
      type: '',
      required: false,
      options: [],
      maxGrade: 0,
      shortAnswer: '',
      minGrade: 0,
      questionLabel: '',
      scaleLabels: {}
    }]);
  }

  console.log(questions, 'questions');
  const method = useForm<EventFormValues>({
    mode: 'onChange',
  });
  const {
    formState: { dirtyFields, isDirty },
  } = method;
  const submitFeedback = () => {
    const payload: any = {
      parameters: questions.map((q, idx) => {
        const param: any = {
          questionLabel: q.questionLabel,
          required: q.required,
          order: idx + 1,
          type: q.type,
          options: Array.isArray(q.options) && q.options.length > 0 ? q.options.join(';') : "",
          minGrade: q.minGrade,
          maxGrade: q.maxGrade,
          minGradeLabel: q.scaleLabels?.[q.minGrade] || 0,
          maxGradeLabel: q.scaleLabels?.[q.maxGrade] || 0
        };
        // if (q.options && q.options.length > 0) {
        //   param.options = q.options;
        // }
        // if (q.type === 'Linear Scale') {
        //   if (q.minGrade !== undefined && q.minGrade !== "" && q.maxGrade !== undefined && q.maxGrade !== "") {
        //     param.minGrade = q.minGrade;
        //     param.maxGrade = q.maxGrade;
        //     param.minGradeLabel = q.scaleLabels?.[q.minGrade] || '';
        //     param.maxGradeLabel = q.scaleLabels?.[q.maxGrade] || '';
        //   }
        // }
        return param;
      }),
      sessionId: selectedSession?.Id,
      sessionTitle: selectedSession?.Name
    };
    console.log(payload, "payloadpayloadpayloadpayload");

    postEventQuestionnaire(payload).then((res) => {
      if (res?.success === 'true') {
        enqueueSnackbar('Feedback form add successfully', { variant: 'success' });
        handleCloseDialog();
      } else {
        enqueueSnackbar('Something went wrong', { variant: 'error' });
      }
    })
  }
  const removeQuestion = (id: number) => {
    setQuestions(questions.filter((question) => question.id !== id));
  };
  const handleFieldChange = (callback: Function, ...args: any[]) => {
    callback(...args);
  };

  const handleTypeChange = (id: number, type: string) => {
    handleFieldChange(
      (id: number, type: string) => {
        setQuestions(questions.map((question) => (question.id === id ? { ...question, type } : question)));
      },
      id,
      type
    );
  };
  const handleLabelChange = (id: number, questionLabel: string) => {
    setQuestions((prevQuestions) => {
      return prevQuestions.map((question) =>
        question.id === id && question.questionLabel !== questionLabel
          ? { ...question, questionLabel }
          : question
      );
    });
  };

  const handleRequiredChange = (id: number, required: boolean) => {
    handleFieldChange(
      (id: number, required: boolean) => {
        setQuestions(questions.map((question) => (question.id === id ? { ...question, required } : question)));
      },
      id,
      required
    );
  };
  const handleMCQOptionChange = (id: number, index: number, value: string) => {
    handleFieldChange(
      (id: number, index: number, value: string) => {
        setQuestions(
          questions.map((question) =>
            question.id === id
              ? {
                ...question,
                options: question.options.map((opt, idx) => (idx === index ? value : opt)),
              }
              : question
          )
        );
      },
      id,
      index,
      value
    );
  };
  const handleShortAnswerChange = (id: number, answer: string) => {
    handleFieldChange(
      (id: number, answer: string) => {
        setQuestions(questions.map((question) => (question.id === id ? { ...question, shortAnswer: answer } : question)));
      },
      id,
      answer
    );
  };
  const handleMinGradeChange = (id: number, minGrade: number) => {
    setQuestions(questions.map((question) =>
      question.id === id
        ? {
          ...question,
          minGrade,
          // If maxGrade is less than/equal to minGrade, reset maxGrade
          maxGrade: question.maxGrade !== undefined && question.maxGrade > minGrade ? question.maxGrade : undefined,
        }
        : question
    ));
  };

  const handleMaxGradeChange = (id: number, maxGrade: number) => {
    setQuestions(questions.map((question) =>
      question.id === id
        ? { ...question, maxGrade }
        : question
    ));
  };

  function handleRemoveOption(id: number, idx: number) {
    handleFieldChange(
      (id: number, idx: number) => {
        setQuestions(questions.map((question) => (question.id === id ? { ...question, options: question.options.filter((_, index) => index !== idx) } : question)));
      },
      id,
      idx
    );
  }
  function handleAddOption(id: number) {
    handleFieldChange(
      (id: number) => {
        setQuestions(questions.map((question) => (question.id === id ? { ...question, options: [...question.options, `Option ${question.options.length + 1}`] } : question)));
      },
      id
    );
  }
  function handleScaleLabelChange(id: number, idx: number, value: string): void {
    handleFieldChange(
      (id: number, idx: number, value: string) => {
        setQuestions(
          questions.map((question) =>
            question.id === id
              ? {
                ...question,
                scaleLabels: {
                  ...question.scaleLabels,
                  [idx]: value,
                },
              }
              : question
          )
        );
      },
      id,
      idx,
      value
    );
  }
  const addQuestion = () => {
    const newQuestion: Question = {
      id: questions.length + 1,
      type: '',
      required: false,
      options: [],
      maxGrade: undefined,
      shortAnswer: '',
      minGrade: undefined,
      questionLabel: '',
      scaleLabels: {}
    };
    setQuestions([...questions, newQuestion]);
  };

  const isMobile = window.innerWidth <= 600; // Add this line

  return (
    <div style={{ marginTop: '20px' }}>
      {sessions.map((session, index) => (
        <Grid
          key={session.Id}
          container
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          style={{ padding: '20px', borderRadius: '12px', border: "1px solid #D1D4DB", marginBottom: '12px' }}
        >
          <Grid item md={1.5} lg={1.5} xs={3} sm={3}>
            <Typography fontSize="14px" fontWeight={600} color="#000000">
              Session {index + 1}
            </Typography>
          </Grid>
          <Grid item md={7.5} lg={7.5} xs={5} sm={5} textAlign="left">
            <Typography fontSize="14px" fontWeight={500} color="#000000">
              {session.Name}
            </Typography>
            <Typography fontSize="12px">
              Date : {formatDate(session.Start_Date__c)}
            </Typography>
          </Grid>
          <Grid item md={3} lg={3} xs={4} sm={4} textAlign="right">
            <Button
              style={{
                background: "linear-gradient(90deg, #4B3776, #FFE090)",
                color: "#5B4200",
                borderRadius: 12,
                width: "100%"
              }}
              onClick={() => handleTriggerFeedbackForm(session)}
            >
              {isMobile ? "+ Feedback" : "Setup feedback form"}
            </Button>
          </Grid>
        </Grid>
      ))}

      <Grid>
        <Dialog
          open={triggerFeedbackForm}
          onClose={() => {
            handleCloseDialog();
          }}
          fullScreen={isMobile} // Make dialog fullscreen on mobile
          sx={{
            '& .MuiDialog-paper': {
              borderRadius: isMobile ? 0 : '12px',
              maxWidth: isMobile ? '100vw !important' : "100% !important",
              width: isMobile ? '100vw' : undefined,
              minHeight: isMobile ? '100vh' : undefined,
              margin: isMobile ? 0 : undefined,
            },
          }}
        >
          <Box
            component={'div'}
            className="d-flex flex-column justify-content-between"
            padding={isMobile ? '0px' : '24px'}
            width={isMobile ? '100vw' : '1000px'}
            height={isMobile ? '100vh' : '100%'}
            sx={{
              background: isMobile ? '#fff' : undefined,
              overflowY: isMobile ? 'auto' : undefined,
            }}
          >
            <Box
              component={'div'}
              className="d-flex flex-column"
              gap={'24px'}
              sx={{
                padding: isMobile ? '16px 16px 0 16px' : 0,
                borderBottom: isMobile ? '1px solid #E0E0E0' : 'none',
              }}
            >
              <Typography
                color={KenColors.ClientBlack2}
                fontSize={isMobile ? '16px' : '18px'}
                fontWeight={'500'}
                sx={{
                  textAlign: isMobile ? 'center' : 'left',
                  paddingBottom: isMobile ? '8px' : 0,
                }}
              >
                Setup feedback {selectedSession?.Name} form
              </Typography>
            </Box>
            <Grid>
              <Box
                component={'div'}
                className="d-flex flex-column"
                gap={'24px'}
                margin={isMobile ? '0px' : '30px 0px'}
                sx={{
                  padding: isMobile ? '0 8px' : 0,
                }}
              >
                <Box component={'div'} className="d-flex flex-column" gap={'24px'}>
                  <FormProvider {...method}>
                    <Grid item xs={12} md={12}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={`${classes.gridContainer} scrollbar-cusgray`}
                        sx={{
                          maxHeight: isMobile ? 'calc(100vh - 200px)' : undefined,
                          overflowY: isMobile ? 'auto' : undefined,
                        }}
                      >
                        {questions.map((question, index) => (
                          <Grid
                            key={question.id}
                            style={{
                              backgroundColor: '#F6F8FB',
                              borderRadius: '9px',
                              margin: isMobile ? "10px 0px" : "0px 0px 20px 0px",
                              border: '0.38px solid #5981FF',
                            }}
                          >
                            <Grid
                              container
                              style={{ marginTop: 10 }}
                              direction={isMobile ? 'column' : 'row'}
                            >
                              <Grid
                                item
                                lg={6}
                                sm={6}
                                md={6}
                                xs={12}
                                padding={isMobile ? 1 : 2}
                              >
                                <Typography
                                  sx={{
                                    fontSize: '12px !important',
                                    fontWeight: 500,
                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                      fontSize: '12px !important',
                                    },
                                  }}
                                >
                                  Question {index + 1}
                                </Typography>
                                <TextField
                                  value={question.questionLabel}
                                  sx={{
                                    marginTop: '10px',
                                    width: '100%',
                                    height: '36px',
                                    fontSize: '12px',
                                    backgroundColor: 'white',
                                    '& .MuiInputBase-root': {
                                      height: '36px',
                                      fontSize: '12px',
                                    },
                                  }}
                                  placeholder="Untitled question"
                                  onChange={(event) => handleLabelChange(question.id, event.target.value)}
                                />
                              </Grid>
                              <Grid
                                item
                                lg={6}
                                sm={6}
                                md={6}
                                xs={12}
                                padding={isMobile ? 1 : 2}
                              >
                                <Typography
                                  sx={{
                                    fontSize: '12px !important',
                                    fontWeight: 500,
                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                      fontSize: '12px !important',
                                    },
                                  }}
                                >
                                  Choose type
                                </Typography>
                                <FormControl fullWidth style={{ backgroundColor: 'white' }}>
                                  <Select
                                    value={question.type}
                                    onChange={(event) => handleTypeChange(question.id, event.target.value as string)}
                                    sx={{
                                      marginTop: '10px',
                                      height: '36px',
                                      '& .MuiOutlinedInput-root': {
                                        height: '36px',
                                        fontSize: '12px',
                                      },
                                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#3061FF',
                                      },
                                    }}
                                  >
                                    {defaultOptions.map((option, idx) => (
                                      <MenuItem
                                        key={idx}
                                        value={option}
                                        sx={{
                                          fontSize: '12px',
                                          height: '36px',
                                          '&.Mui-selected': {
                                            backgroundColor: 'transparent',
                                          },
                                          '&.Mui-selected:hover': {
                                            backgroundColor: 'transparent',
                                          },
                                          '&:hover': {
                                            backgroundColor: 'transparent',
                                          },
                                          '&:active': {
                                            backgroundColor: 'transparent',
                                          },
                                        }}
                                      >
                                        {option}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                            </Grid>
                            <Grid padding={isMobile ? 1 : 2}>
                              {question.type === 'Multiple Choice' && (
                                <>
                                  {question.options.map((opt, idx) => (
                                    <React.Fragment key={idx}>
                                      <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={0.5}>
                                          <span style={{ fontWeight: 'bold', fontSize: 16 }}>{alphabet[idx] || ''}.</span>
                                        </Grid>
                                        <Grid item xs={4} style={{ marginLeft: '10px' }}>
                                          <TextField
                                            value={opt}
                                            onChange={(e) => handleMCQOptionChange(question.id, idx, e.target.value)}
                                            placeholder={`Option ${idx + 1}`}
                                            sx={{
                                              marginTop: '10px',
                                              width: '100%',
                                              height: '36px',
                                              fontSize: '12px',
                                              backgroundColor: 'white',
                                              '& .MuiInputBase-root': {
                                                height: '36px',
                                                fontSize: '12px',
                                              },
                                            }}
                                          />
                                        </Grid>
                                        <Grid item xs={4} display={'flex'}>
                                          <CloseIcon onClick={() => handleRemoveOption(question.id, idx)} sx={{ fontSize: '18px', marginTop: '20px' }} />
                                        </Grid>
                                      </Grid>
                                      <Divider style={{ marginTop: '0px', width: '50%' }} />
                                    </React.Fragment>
                                  ))}
                                  <Button style={{ marginTop: 10 }} onClick={() => handleAddOption(question.id)}>Add Option</Button>
                                </>
                              )}
                              {question.type === 'Yes/No' && (
                                <>
                                  {question.options.map((opt, idx) => (
                                    <React.Fragment key={idx}>
                                      <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={0.5}>
                                          <span style={{ fontWeight: 'bold', fontSize: 16 }}>{alphabet[idx] || ''}.</span>
                                        </Grid>
                                        <Grid item xs={4} style={{ marginLeft: '10px' }}>
                                          <TextField
                                            value={opt}
                                            onChange={(e) => handleMCQOptionChange(question.id, idx, e.target.value)}
                                            placeholder={`Option ${idx + 1}`}
                                            sx={{
                                              marginTop: '10px',
                                              width: '100%',
                                              height: '36px',
                                              fontSize: '12px',
                                              backgroundColor: 'white',
                                              '& .MuiInputBase-root': {
                                                height: '36px',
                                                fontSize: '12px',
                                              },
                                            }}
                                          />
                                        </Grid>
                                        <Grid item xs={4} display={'flex'}>
                                          <CloseIcon onClick={() => handleRemoveOption(question.id, idx)} sx={{ fontSize: '18px', marginTop: '20px' }} />
                                        </Grid>
                                      </Grid>
                                      <Divider style={{ marginTop: '0px', width: '50%' }} />
                                    </React.Fragment>
                                  ))}
                                  <Button style={{ marginTop: 10 }} onClick={() => handleAddOption(question.id)}>Add Option</Button>
                                </>
                              )}
                              {question.type === 'Linear Scale' && (
                                <Grid>
                                  <Grid container alignItems="center">
                                    <Grid item>
                                      <Box sx={{ minWidth: 100 }}>
                                        <FormControl style={{ width: 80, backgroundColor: '#FFFFFF' }}>
                                          <Select
                                            value={question.minGrade ?? ''}
                                            onChange={(e) => handleMinGradeChange(question.id, Number(e.target.value))}
                                            sx={{
                                              height: '36px',
                                              fontSize: '12px',
                                              '& .MuiOutlinedInput-root': {
                                                height: '36px',
                                                fontSize: '12px',
                                              },
                                              '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#3061FF',
                                              },
                                            }}
                                          >
                                            {[0, 1].map((value) => (
                                              <MenuItem
                                                key={value}
                                                value={value}
                                                sx={{
                                                  fontSize: '12px',
                                                  height: '36px',
                                                  '&.Mui-selected': {
                                                    backgroundColor: 'transparent',
                                                  },
                                                  '&.Mui-selected:hover': {
                                                    backgroundColor: 'transparent',
                                                  },
                                                  '&:hover': {
                                                    backgroundColor: 'transparent',
                                                  },
                                                  '&:active': {
                                                    backgroundColor: 'transparent',
                                                  },
                                                }}
                                              >
                                                {value}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                      </Box>
                                    </Grid>
                                    <Grid item paddingRight={2}>
                                      <Typography fontWeight={'bold'}>to</Typography>
                                    </Grid>
                                    <Grid item>
                                      <Box sx={{ minWidth: 120 }}>
                                        <FormControl style={{ width: 80, backgroundColor: '#FFFFFF' }}>
                                          <Select
                                            value={question.maxGrade ?? ''}
                                            onChange={(e) => handleMaxGradeChange(question.id, Number(e.target.value))}
                                            sx={{
                                              height: '36px',
                                              fontSize: '12px',
                                              '& .MuiOutlinedInput-root': {
                                                height: '36px',
                                                fontSize: '12px',
                                              },
                                              '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#3061FF',
                                              },
                                            }}
                                          >
                                            {/* Show maxGrade options based on minGrade */}
                                            {question.minGrade !== undefined &&
                                              Array.from({ length: 5 - question.minGrade }, (_, i) => question.minGrade! + i + 1).map((value) => (
                                                <MenuItem
                                                  key={value}
                                                  value={value}
                                                  sx={{
                                                    fontSize: '12px',
                                                    height: '36px',
                                                    '&.Mui-selected': {
                                                      backgroundColor: 'transparent',
                                                    },
                                                    '&.Mui-selected:hover': {
                                                      backgroundColor: 'transparent',
                                                    },
                                                    '&:hover': {
                                                      backgroundColor: 'transparent',
                                                    },
                                                    '&:active': {
                                                      backgroundColor: 'transparent',
                                                    },
                                                  }}
                                                >
                                                  {value}
                                                </MenuItem>
                                              ))}
                                          </Select>
                                        </FormControl>
                                      </Box>
                                    </Grid>
                                  </Grid>
                                  {/* Show only min and max label fields */}
                                  <Grid container alignItems="center" padding={2}>
                                    <b style={{ width: 30 }}>{question.minGrade ?? ''}</b>
                                    <TextField
                                      placeholder="Label (Optional)"
                                      value={question.scaleLabels?.[question.minGrade ?? 0] || ''}
                                      onChange={(e) => handleScaleLabelChange(question.id, question.minGrade ?? 0, e.target.value)}
                                      sx={{
                                        width: '40vh',
                                        backgroundColor: 'white',
                                        '& .MuiInputBase-input': {
                                          fontSize: '12px',
                                          height: '36px',
                                          padding: '8px 14px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                          height: '36px',
                                        },
                                      }}
                                    />
                                  </Grid>
                                  <Grid container alignItems="center" padding={2}>
                                    <b style={{ width: 30 }}>{question.maxGrade ?? ''}</b>
                                    <TextField
                                      placeholder="Label (Optional)"
                                      value={question.scaleLabels?.[question.maxGrade ?? 0] || ''}
                                      onChange={(e) => handleScaleLabelChange(question.id, question.maxGrade ?? 0, e.target.value)}
                                      sx={{
                                        width: '40vh',
                                        backgroundColor: 'white',
                                        '& .MuiInputBase-input': {
                                          fontSize: '12px',
                                          height: '36px',
                                          padding: '8px 14px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                          height: '36px',
                                        },
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              )}
                              {question.type === 'Short Answer' && (
                                <textarea
                                  rows={6}
                                  value={question.shortAnswer}
                                  onChange={(e) => handleShortAnswerChange(question.id, e.target.value)}
                                  style={{ border: '0.5px solid #bdbfc1', padding: 10, borderRadius: 4, width: 400 }}
                                  placeholder="Short answer"
                                />
                              )}
                            </Grid>
                            <Grid padding={1} style={{ padding: isMobile ? 10 : 20 }}>
                              <Grid style={{ float: isMobile ? 'none' : 'right', margin: isMobile ? '0px' : '-20px 15px 0px 0px', display: 'flex', alignItems: 'center', justifyContent: isMobile ? 'flex-end' : 'flex-end' }}>
                                <span style={{ fontWeight: 500, paddingRight: 20, paddingLeft: 20, fontSize: '12px' }}> Required</span>
                                <Switch checked={question.required} onChange={(e) => handleRequiredChange(question.id, e.target.checked)} />
                                <DeleteOutlineIcon style={{ cursor: 'pointer' }} onClick={() => removeQuestion(question.id)} />
                              </Grid>
                            </Grid>
                          </Grid>
                        ))}
                        <Grid style={{ marginLeft: isMobile ? 0 : 25, marginTop: isMobile ? 10 : 0 }}>
                          <Button
                            style={{
                              backgroundColor: '#E8EBF3',
                              color: '#373A45',
                              width: isMobile ? '100%' : undefined,
                            }}
                            startIcon={<AddIcon />}
                            onClick={addQuestion}
                          >
                            <Typography sx={{ fontSize: '12px' }}>Add Question</Typography>
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </FormProvider>
                </Box>
              </Box>
            </Grid>
            <Box
              component={'div'}
              className="d-flex align-items-center"
              gap={'12px'}
              sx={{
                flexDirection: isMobile ? 'column' : 'row',
                padding: isMobile ? '16px' : 0,
                borderTop: isMobile ? '1px solid #E0E0E0' : 'none',
                marginTop: isMobile ? 'auto' : undefined,
              }}
            >
              <AppButton
                variant="text"
                fullWidth
                size="medium"
                others={{
                  color: KenColors.ClientBlack2,
                }}
                onClick={() => {
                  handleCloseDialog();
                }}
                sx={{
                  marginBottom: isMobile ? '8px' : 0,
                }}
              >
                Cancel
              </AppButton>
              <AppButton
                variant="contained"
                fullWidth
                size="medium"
                onClick={() => {
                  submitFeedback();
                }}
                sx={{color:"#5b4200"}}
              >
                Submit request
              </AppButton>
            </Box>
          </Box>
        </Dialog>
      </Grid>
    </div>
  );

}
export default FeedBackForm;